<template>
<div class="chapter">
<div class="inner_page">
<p class="h2"><a id="page_xvi"></a><a id="page_xvii"></a><a id="tab"></a><strong>TABLES</strong></p>
<p class="toc-a"><a href="#/html/9780226160702_11_ch1#tab1">1. Negro Population of Chicago, 1850–1930</a></p>
<p class="toc-a"><a href="#/html/9780226160702_11_ch1#tab2">2. State of Birth of Native Non-Whites, Chicago, 1900</a></p>
<p class="toc-a"><a href="#/html/9780226160702_12_map1#tab3">3. Negro Population by Ward, Chicago, 1900 and 1910</a></p>
<p class="toc-a"><a href="#/html/9780226160702_12_map1#tab4">4. Concentration of Negroes in Chicago, 1898–1920</a></p>
<p class="toc-a"><a href="#/html/9780226160702_12_map1#tab5">5. State of Birth of Illinois Negroes, 1900–1910</a></p>
<p class="toc-a"><a href="#/html/9780226160702_13_ch2#tab6">6. Males and Females Over Ten Engaged in Selected Occupations, Chicago, 1900</a></p>
<p class="toc-a"><a href="#/html/9780226160702_13_ch2#tab7">7. Males and Females Over Ten Engaged in Selected Occupations, Chicago, 1910</a></p>
<p class="toc-a"><span href="#/html/9780226160702_19_ch7#tab8" title="Link target outside of Sample">8. Nativity of Negroes, Chicago, 1910–20</span></p>
<p class="toc-a"><span href="#/html/9780226160702_19_ch7#tab9" title="Link target outside of Sample">9. State of Birth of Illinois Negroes, 1910–20</span></p>
<p class="toc-a"><span href="#/html/9780226160702_19_ch7#tab10" title="Link target outside of Sample">10. Distribution of Negroes by Census Tracts, Chicago, 1910–20</span></p>
<p class="toc-a"><span href="#/html/9780226160702_19_ch7#tab11" title="Link target outside of Sample">11. Ten Census Tracts with Highest Negro Percentage, Chicago, 1910–20</span></p>
<p class="toc-a"><span href="#/html/9780226160702_20_ch8#tab12" title="Link target outside of Sample">12. Males and Females Over Ten Engaged in Selected Occupations, Chicago, 1920</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226160702_08_tab.vue?448bcfea